<div class="di-loader_overlay">
	<lua-overlay *ngIf="visible">
		<div class="di-loader">
			<lua-loader-circulaire [size]="size" [color]="color"></lua-loader-circulaire>
			<p class="text">{{ loaderText }}</p>
		</div>
	</lua-overlay>
</div>